import { ChangeEvent, useEffect, useState } from "react";
import axios from "axios";
import { getDataWithToken, getEndPoint, postData } from "../../../Utils/network.client";
import { API_END_POINT } from "../../../constants";
import { useGetDroppingPoint } from "../../../apiclient/party/useGetDropingPointApi";
import { useGetAllProducts, useGetProducts } from "../../../apiclient/product/useGetProductApi";
import { Formik, Form } from "formik";
import { EmployeeFreeMilk } from "../../../models/transaction/employeefreemilk-model";

export const EmployeeFreeMilkPage: React.FC = () => {
    const [productData, setProductData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedProduct } = useGetAllProducts();

    const [droppingPointData, setDroppingPointData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedDroppingPoint } = useGetDroppingPoint();

    const [droppingPoint, setDroppingPoint] = useState<number>(0);
    const [product, setProduct] = useState<number>(0);

    const [showGrid, setShowGrid] = useState(false);
    const [fetchedEmployeeList, setFetchedEmployeeList] = useState<EmployeeFreeMilk[]>([])

    const [effectDate, setOrderDate] = useState<string>("");

    useEffect(() => {
        const today = new Date();
        const day = today.getDate().toString().padStart(2, '0');
        const ordermonth = today.toLocaleString('default', { month: 'short' }).toUpperCase(); // Get short month (e.g., JAN)
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();

        const formatted1Date = `${year}-${month}-${day}`;
        const formattedDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        setOrderDate(formatted1Date);
    });

    // Effect to set the fetched data for dropping points and products
    useEffect(() => {
        if (fetchedDroppingPoint) {
            const mappedDroppingPoint = fetchedDroppingPoint.map((droppingpoint: any) => ({
                value: droppingpoint.droppingpointId,
                label: droppingpoint.code + "-" + droppingpoint.name
            }));
            setDroppingPointData(mappedDroppingPoint);
        }

        if (fetchedProduct) {
            const mappedProduct = fetchedProduct.map((product: any) => ({
                value: product.productId,
                label: product.code + "-" + product.productName
            }));
            setProductData(mappedProduct);
        }
    }, [fetchedDroppingPoint, fetchedProduct]);
    console.log(productData);

    // Function to fetch data based on selected dropping point and product
    const getEmployeeFreeMilk = async () => {
        try {
            const GetEmployeeFreeMilkByDroppingIdProductId = getEndPoint(API_END_POINT.ORDER) + `/api/EmployeeFreeMilk/GetEmployeeFreeMilk/${droppingPoint}/${product}`;
            const response = await getDataWithToken<any>(GetEmployeeFreeMilkByDroppingIdProductId);

            // Process the response if necessary, e.g., storing it in state
            const EmployeeList = response?.data?.result;
            setFetchedEmployeeList(EmployeeList);
            console.log('Employee Free Milk Data:', response.data);
            setShowGrid(true);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Handle the change for Dropping Point
    const handleDroppingPointChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        setDroppingPoint(Number(event.target.value)); // Convert to number
    };

    // Handle the change for Product
    const handleProductChange = (event: ChangeEvent<HTMLSelectElement>): void => {
        setProduct(Number(event.target.value)); 
    };

    const handleQtyChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, type: string) => {
        const updatedList = [...fetchedEmployeeList];
        const updatedItem = updatedList[index];

        let value = Number(e.target.value);
        if (isNaN(value) || value < 0) {
            value = 0;  // Set to 0 if invalid or negative
        }
        if (type === 'morningSupplyQty') {
            updatedItem.morningSupplyQty = value;
        } else if (type === 'eveningSupplyQty') {
            updatedItem.eveningSupplyQty = value;
        }
        /*   updatedItem.amount = ((Number(updatedItem.morningsupplyqty) + Number(updatedItem.eveningsupplyqty)) * Number(updatedItem.rate.basicRate)) * daysDifference; */
        //updatedItem.amount = amount * daysDifference
        updatedList[index] = updatedItem;

        setFetchedEmployeeList(updatedList);

        console.log("12", fetchedEmployeeList);
        /*   calculateTotalAmount(updatedList); */
    };

    const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedEmployeeList = [...fetchedEmployeeList];
        updatedEmployeeList[index].isActive = e.target.checked; // Toggle checkbox state
        setFetchedEmployeeList(updatedEmployeeList); // Update the employee list state
    };

    const handleSave = async (employee: any) => {
        // alert(employee)
        console.log('Saved product details:', employee);

        employee.effectDate = effectDate;

        try {
           /*  const response = await axios.post(getEndPoint(API_END_POINT.ORDER) + "/api/EmployeeFreeMilk/SaveEmployeeFreeMilk", JSON.stringify(employee),
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            ); */
             const response = await postData<any>(API_END_POINT.ORDER,
                          "EmployeeFreeMilk/SaveEmployeeFreeMilk",
                          "POST",
                          "application/json",
                          employee,
                        );

            if (response.status === 200) {
                console.log('Employee saved successfully:');
                getEmployeeFreeMilk();
                alert('Employee saved successfully'); // throw new Error('Failed to save employee');
            } else {
                throw new Error('Failed to save employee');
            }
        }
        catch (error) {
            console.error('Error saving employee:', error);
            alert('Error saving employee');
        }

    };


    return (
        <Formik
            initialValues={{ droppingPointId: 0, productId: 0 }}
            onSubmit={(values) => {
                // When form is submitted (i.e., when "Get" button is clicked), call getEmployeeFreeMilk
                console.log("Form submitted with values:", values);
                getEmployeeFreeMilk(); // Fetch data on form submission
            }}
        >
            {({ setFieldValue, values }) => (
                <Form>
                    <div className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15" style={{ minHeight: "500px" }}>
                        <div className="top-sec-align row">
                            <center>
                                <h4 className="text-normal title-web mb-0 report-title-color">Employee Free Milk</h4>
                            </center>
                        </div>
                        <div className="fade_rule"></div>
                        <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                            <div className="d-flex">
                                <div className="me-2">
                                    {/*  <label>Dropping Point</label> */}
                                    {/*  <div>DroppingPoint</div> */}
                                    <label className="employee-label">Dropping Point</label>
                                    <select
                                        value={droppingPoint}
                                        onChange={handleDroppingPointChange}
                                        className="input"
                                        style={{ width: '250px' }}
                                    >
                                        <option value="">Please Select</option>
                                        {droppingPointData.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="me-2">
                                    <label className="employee-label">Product</label>
                                    <select
                                        value={product}
                                        onChange={handleProductChange}
                                        className="input"
                                        style={{ width: '250px' }}
                                    >
                                        <option value="">Please Select</option>
                                        {productData.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label></label>
                                    <button
                                        className="btn-primary btn search-btn mt-4"
                                        type="submit" // Using Formik's submit

                                    >
                                        Get
                                    </button>
                                </div>
                            </div>
                        </div>

                        {showGrid && (
                            <div className="emplyeetable-container">
                                <table className="employee-table">
                                    <thead>
                                        <tr>
                                            <th>Employee</th>
                                            <th>Mor Qty/Pkts</th>
                                            <th>Eve Qty/Pkts</th>
                                            <th>Active</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fetchedEmployeeList.length > 0 ? (
                                            fetchedEmployeeList.map((employee, index) => (
                                                <tr key={index}>
                                                    <td>{employee.employeeName}</td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            value={employee.morningSupplyQty}
                                                            onChange={(e) => handleQtyChange(e, index, 'morningSupplyQty')}
                                                            className="qty-inputbox"
                                                            onInput={(e: React.FormEvent<HTMLInputElement>) => {
                                                                const inputValue = (e.target as HTMLInputElement).value;
                                                                // Limit the input to 5 digits
                                                                if (inputValue.length > 4) {
                                                                    (e.target as HTMLInputElement).value = inputValue.slice(0, 4);
                                                                }
                                                            }}
                                                            style={{ borderColor: employee.productColor, width: 100, padding: 2, textAlign: "right" }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            value={employee.eveningSupplyQty}
                                                            onChange={(e) => handleQtyChange(e, index, 'eveningSupplyQty')}
                                                            className="qty-inputbox"
                                                            onInput={(e: React.FormEvent<HTMLInputElement>) => {
                                                                const inputValue = (e.target as HTMLInputElement).value;
                                                                // Limit the input to 5 digits
                                                                if (inputValue.length > 4) {
                                                                    (e.target as HTMLInputElement).value = inputValue.slice(0, 4);
                                                                }
                                                            }}
                                                            style={{ borderColor: employee.productColor, width: 100, padding: '2px', textAlign: "right" }}
                                                        />
                                                    </td>
                                                    <td>
                                                        {/* <input
                                                            type="checkbox"
                                                            className="activecheckbox-input"
                                                            checked={employee.isActive || false} // Default to false if no value
                                                            onChange={(e) => handleCheckboxChange(e, index)}
                                                        /> */}
                                                        <label className="custom-actviecheckbox-container">
                                                            <input
                                                                type="checkbox"
                                                                checked={employee.isActive || false} // Default to false if no value
                                                                onChange={(e) => handleCheckboxChange(e, index)}
                                                                className="activecheckbox-input"
                                                            />
                                                            <span className="activecheckmark"></span>
                                                        </label>
                                                    </td>

                                                    <td>
                                                        <button
                                                            onClick={() => handleSave(employee)}
                                                            className="save-button"
                                                        >

                                                            <span className="save-icon"></span> Save
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr className="no-data">
                                                <td colSpan={5} style={{ textAlign: "center", color: "gray" }}>
                                                    No Data Available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default EmployeeFreeMilkPage;